<!------------------------------------------------>
<!-- HTML定義 ------------------------------------->
<!------------------------------------------------>
<!-- 保育者画面の共通メニュー部 -->
<template>
<body>

    <span>
      <div style="width:100%;background-color:#efefef;">

          <button type="button" class="menu_btn" v-on:click="open=!open" data-cursor-hover>
              <span class="h_line line_01" v-bind:class="{'btn_line01':open}"></span>
              <span class="h_line line_02" v-bind:class="{'btn_line02':open}"></span>
              <span class="h_line line_03" v-bind:class="{'btn_line03':open}"></span>
          </button>
          <div class="menu" v-bind:class="{'is-active' : open }">
              <router-link to="/" class="header_btn en_font" v-bind:class="{'menu_open1':open}" data-cursor-hover>
                  <btn style="color:#FFF;" v-on:click="open=!open">
                      TOP
                  </btn>
              </router-link>

              <router-link to="/Career" class="header_btn en_font" v-bind:class="{'menu_open2':open}" data-cursor-hover>
                  <btn style="color:#FFF;" v-on:click="open=!open">
                      Career
                  </btn>
              </router-link>

              <router-link to="/MemberInterview" class="header_btn en_font" v-bind:class="{'menu_open3':open}" data-cursor-hover>
                  <btn style="color:#FFF;" v-on:click="open=!open">
                      Member Interview
                  </btn>
              </router-link>

              <router-link to="/Welfare" class="header_btn en_font" v-bind:class="{'menu_open4':open}" data-cursor-hover>
                  <btn style="color:#FFF;" v-on:click="open=!open">
                      Welfare
                  </btn>
              </router-link>

              <router-link to="/Infographics" class="header_btn en_font" v-bind:class="{'menu_open5':open}" data-cursor-hover>
                  <btn style="color:#FFF;" v-on:click="open=!open">
                      Infographics
                  </btn>
              </router-link>

              <router-link to="/ApplicationType" class="header_btn en_font" v-bind:class="{'menu_open5':open}" data-cursor-hover>
                  <btn style="color:#FFF;" v-on:click="open=!open">
                      Recruitment Type
                  </btn>
              </router-link>
          </div>
      </div>

      <!-- <router-link to="/" class="recruit_logo" :class='[test === false ? "none" : ""]'> -->
      <router-link to="/" class="recruit_logo" v-if="$route.name.indexOf('Portal/') < 0" v-show="!open">
        <svg_elements name="recruit_logo" width="50px" data-cursor-hover />
      </router-link>

      <!-- <div 
        style="width:100%;height:50px;background-color:#efefef;z-index:3;position:fixed;opacity:.5;"
        v-if="$route.name.indexOf('Portal/') < 0" 
      /> -->

    </span>
    </body>
</template>

<script>
import svg_elements from "@/assets/svg_elements";
export default {
    name: 'HeaderItem01',
    components: {
        svg_elements
    },
    data() {
        return {
            open: false
        };
    },
    computed: {
        
    },
    methods: {
        // ログアウトリンク押下
        clickLogout: function () {
            this.$store.dispatch('auth/logout')
            this.$router.replace('/login')
        },
    }
};

</script>

<!-- style中身は省略 -->
<style>
@import "../css/Portal_base.css";

.header_btn{
  margin: 5px;
  text-decoration: none;
  font-size: 2em;
  opacity: 0;
  transform: translateY(-50%);
  cursor: none;
}
.header_btn btn:hover{
  cursor: none;
}
.header_btn:hover{
  cursor: none;
}
.header_btn::after {
  position: absolute;
  bottom: 2px;
  left: 0;
  content: '';
  width: 100%;
  height: 1px;
  background: #fff;
  opacity: 0;
  visibility: hidden;
  transition: .3s;
}
.header_btn:hover::after {
  bottom: -2px;
  opacity: 1;
  visibility: visible;
}
.menu_open1{
  opacity: 1;
  transition: all 1s;
  transition-delay: .2s;
}
.menu_open2{
  opacity: 1;
  transition: all 1s;
  transition-delay: .4s;
}
.menu_open3{
  opacity: 1;
  transition: all 1s;
  transition-delay: .6s;
}
.menu_open4{
  opacity: 1;
  transition: all 1s;
  transition-delay: .8s;
}
.menu_open5{
  opacity: 1;
  transition: all 1s;
  transition-delay: 1s;
}

.menu_btn .h_line {
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  height: 2px;
  text-align: center;
  border-bottom: solid 2px #C04D00;
  animation-name: head_border_anim;/*1で解説*/
  animation-fill-mode:backwards;/*2で解説*/
  animation-duration:3s;/*3で解説*/
  animation-iteration-count:forwards;/*4で解説*/
  animation-timing-function:linear;/*5で解説*/
  animation-delay: 0.5s;/*6で解説*/
  animation-direction:normal;/*7で解説*/
}
/* .line:before{
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  border-bottom: solid 3px #C04D00;
  animation-delay: 0.2s;
  animation-name: head_border_anim;
  animation-fill-mode: forwards;
  animation-timing-function: ease;
  animation-duration:0.5s;
} */
@keyframes head_border_anim {
  0%{
    /* width: 0%; */
    opacity: 0;
  }
  100%{
    /* width: 100%; */
    opacity: 1;
  }
}

.menu_btn .line_01 {
  top: 5px;
  transition: 0.4s ease;
}
.menu_btn .line_02 {
  top: 15px;
  transition: 0.4s ease;
}
.menu_btn .line_03 {
  top: 25px;
  transition: 0.4s ease;
}

.btn_line01 {
  transform: translateY(10px) rotate(-45deg);
  transition: 0.4s ease;
}
.btn_line02 {
  transition: 0.4s ease;
  opacity: 0;
}
.btn_line03 {
  transform: translateY(-10px) rotate(45deg);
  transition: 0.4s ease;
}

/*----------------------------
* メニュー開閉ボタン
*----------------------------*/
.menu_btn{
  position: fixed;
  top: 1em;
  right: 1em;
  width: 30px;
  height: 30px;
  cursor: none;
  z-index: 50;
}

/*----------------------------
* メニュー本体
*----------------------------*/
.menu{
  position: fixed;
  top: 0;
  right: 0;
  z-index: 4;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #ec7700;
  cursor: none;
}


/*----------------------------
* アニメーション部分
*----------------------------*/

/* アニメーション前のメニューの状態 */
.menu{
  transform: translateX(100vw);
  transition: all .3s linear;
}
/* アニメーション後のメニューの状態 */
.menu.is-active{
  transform: translateX(0);
}
@media screen and (max-width: 480px)  {
  .menu{
    font-size: 2rem;
  }
}
@media screen and (min-width: 1201px) and (max-width: 1500px)  {
    .menu.is-active{
        transform: translateX(80);
    }
}
.recruit_logo{
  position: fixed;
  top: 15px;
  left: 20px;
  width: 50px;
  z-index: 5;
  cursor: none;
}
.router-link-active{
  cursor: none !important;
}




/* @keyframes Home_border_anim {
	0%{
		width: 0%;
	}
	100%{
		width: 100%;
	}
} */


</style>
